let api = {
  purchaser: {
    // 获取所有的省
    getCityTree: {
      url: '/purchaser/mall/city/getCityTree',
      type: 'get'
    }
  },
  supplier: {
    getCityTree: {
      url: '/supplier/city/getCityTree',
      type: 'get'
    }
  }
}
export default api
